export const zh = {
  title: '整合的森林砍伐警报',
  subtitle: '每日，10m，热带地区，UMD/GLAD 和 WUR',
  download_data: '使用来自三个警报系统的集成警报，近乎实时地监测森林干扰活动',
  content: [
    {
      label: '功能',
      value: 'https://data.globalforestwatch.org/datasets/gfw::integrated-deforestation-alerts/about',
    },
    {
      label: '分辨率',
      value: '10 × 10 m',
    },
    {
      label: '地理覆盖范围',
      value: '30°N to 30°S',
    },
    {
      label: '来源',
      value:
        'GLAD Alerts:\nHansen, M.C., A. Krylov, A. Tyukavina, P.V. Potapov, S. Turubanova, B. Zutta, S. Ifo, B. Margono, F. Stolle, and R. Moore. 2016. Humid tropical forest disturbance alerts using Landsat data. Environmental Research Letters, 11 (3). (https://dx.doi.org/10.1088/1748-9326/11/3/034008)[https://dx.doi.org/10.1088/1748-9326/11/3/034008]',
    },
    {
      label: '更新频率',
      value: '每日',
    },
    {
      label: '内容日期',
      value: '2019 年 1 月 1 日 - 至今',
    },
    {
      label: '注意事项',
      value:
        '虽然被称为“森林砍伐警报”，但这些警报会检测森林或树木覆盖的干扰活动。本产品不区分人为干扰和其他干扰类型。如果在人工林中检测到警报（在 GLAD-L 系统中更可能发生，则该警报可能代表木材采伐作业，而不会转变为非林地用途。 \n使用森林砍伐一词，是因为这些是潜在的森林砍伐事件，可对警报进行进一步调查以确定。 \n我们不建议将森林砍伐预警用于全球或区域趋势评估，也不建议用于面积估算。我们建议使用年度林木覆盖损失数据，以更准确地比较森林随时间变化的趋势，并用于面积估算。近期预警会包括误报，它们的置信度还不够高，且最终可能会被删除。如果在6个月内先发生林冠快速郁闭，过后又有无遮挡卫星观测信息，则过往预警可能被误删。此外，方法的更新、不同的系统数量（就集成预警而言），以及月和年之间云量的变化，这些因素都给使用森林砍伐预警进行年际/年内比较带来了额外的风险。\n可对预警加以‘精选’，以识别用户关注的预警，例如那些可能是森林砍伐或许需要优先采取行动的预警。用户可以通过叠加其他上下文数据集（例如保护区或人工林）来执行此操作。这里提供了非精选数据，以便用户可以定义自己的排序方法。精选预警位置在“待观测地点”数据图层中提供。\n三个预警系统对森林/树木覆盖和森林/树木覆盖干扰有不同的定义：\n\n\nGLAD-L：警报位于“树木覆盖”范围内，“树木覆盖”的定义为所有高度超过 5 米且树冠覆盖率超过 60% 的植被，可能以天然林或种植园的形式存在。 “树木覆盖损失”表示树冠移除至少半个像素，这可能由多种因素造成，包括机械采伐、火灾、疾病或风暴破坏。因此，“损失”并不等同于森林砍伐。 \nGLAD-S2：警报位于亚马逊河流域 Turubanova et al (2018) 的原始森林掩码内，2001 年至今来自 Hansen et al. (2013) 的森林损失已删除。 \nRADD：预警发生于原始潮湿森林中。林木损失被定义为像素内的林木覆盖完全或部分消失不见，最小映射单位为0.5公顷。 \n输入预警系统不具有相同的时空覆盖范围：\nGLAD-L：从 2018 年 1 月 1 日至今在整个热带地区（30°N 到 30°S）运行，从 2015 年至今（尽管在 2022 年暂停了一段时间）在亚马逊、刚果盆地和东南亚岛屿的指定国家运行 \nGLAD-S2：从 2019 年 1 月至今在南美洲的热带原始湿林地区运行 \nRADD：适用于在南美洲、撒哈拉以南非洲和东南亚岛屿的原始潮湿热带森林地区，时空覆盖范围是非洲从2019年1月至今，南美洲和东南亚从2020年1月至今，中美洲从2023年1月起开始覆盖（2023年底即将扩展到东南亚和太平洋大陆） \n\n为了在一个公共网格上集成三个预警系统，需要对GLAD-L进行重新采样，将空间分辨率从30米缩小到10米，以匹配GLAD-S2和RADD。因此，单个30米GLAD-L像素将在集成图层中变成多个10米像素。用户在将单个系统的分析结果与集成预警图层进行比较时应谨慎，因为集成预警的数量将远远大于原生GLAD-L预警的数量。此外，由于这种重新采样，集成图层中的像素在地图上可能与单个GLAD-L图层中的像素不完全对齐。 \n集成层中的每个像素都会保留所有警报系统的最早检测日期，即使多个系统已在该像素中报告了警报。在某些情况下，在从集成层切换到单独的警报系统层时，可能会产生不一致的可视化效果。如果您对任何警报系统的最早检测日期感兴趣，建议使用集成层。但是，如果您对某个特定的警报类型感兴趣，最好使用单独的警报系统层。 \n“最高置信度：被多个预警系统检测到”级别只能在该区域有多个预警系统作用的时空范围背景下实现。 \n随着源数据的更新，置信度可能发生追溯性变化；在180天内未变为高置信度的预警将从数据集中删除。\n一旦某个预警像素达到高置信度，同一预警系统将不会对该位置再次检测森林损失\n由于三个警报系统的不同特征，集成警报覆盖范围的准确性各不相同——例如，由于短波长 C 波段雷达对湿度变化的高灵敏度，Radar (RADD) 警报在沼泽森林中可能出现更多错误检测\n缩小时，此数据层显示会出现某种程度的不准确性，因为数据点必须折叠才能在更大比例上可见。请放大以获取更多详细信息。',
    },
    {
      label: '许可证',
      value: 'CC by 4.0',
    },
  ],
  overview: {
    label: '概览',
    value:
      '该数据集由 Global Forest Watch 汇编而成，将来自三个警报系统（GLAD-L、GLAD-S2、RADD）的森林砍伐警报汇总到一个单一的、集成的森林砍伐警报层中。相比任何单个系统，这种集成系统可以让用户更快地检测到森林砍伐事件，因为当任何源警报系统更新时，集成层也会更新。',
  },
  citation: {
    label: '引用',
    value: 'Source: "Integrated Deforestation Alerts". UMD/GLAD and WUR, accessed through Global Forest Watch',
  },
};
